module.exports = __webpack_public_path__ + "static/img/Background_image_a@2x.e649073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/Background_image_a@2x.png
// module id = YdTh
// module chunks = 70